<template>
  <div class="tab-table">
    <div class="message">
      {{$t('price-adj.messages.order-tab')}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderTab',
  methods: {
    tileSelected () {
      // active for validation reeason
      // set item_id as fake value
      return this.$emit('tile-selected', { item_id: 'order-item-id' })
    },
    refresh () {
      // refresh component and set the fake value
      // refresh is called by parent (TabsManager) every time tab change
      this.tileSelected()
    }
  }
}
</script>
